import { render, staticRenderFns } from "./AdminMail.vue?vue&type=template&id=6bcfc146&"
import script from "./AdminMail.vue?vue&type=script&lang=js&"
export * from "./AdminMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports